import { Component, Input, OnInit } from '@angular/core';
import { Document } from 'app/documents/document';

@Component({
  selector: 'lms-documents-list-detail',
  templateUrl: './documents-list-detail.component.html',
  styleUrls: ['./documents-list-detail.component.css']
})
export class DocumentsListDetailComponent implements OnInit {
  @Input() document: Document;

  constructor() {}

  ngOnInit() {}
}
